"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EChatChannel = _interopRequireDefault(require("./EChatChannel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = [{
  sentAt: new Date(),
  author: "b4ttl3m4st3r",
  channel: _EChatChannel.default.GUILD,
  message: "hey there whats going on? xD"
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.PARTY,
  message: "not much, hanging around with my bro and listening to music"
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.GUILD,
  message: "hey btw, did you know that you can get a free exp scroll from a special quest in palmas?"
}, {
  sentAt: new Date(),
  author: "WizardOfTheHELL",
  channel: _EChatChannel.default.GENERAL,
  message: "homo lets go kill titans -.-"
}, {
  sentAt: new Date(),
  author: "b4ttl3m4st3r",
  channel: _EChatChannel.default.PARTY,
  message: "you serious ? dam i go do that lol"
}, {
  sentAt: new Date(),
  author: "b4ttl3m4st3r",
  channel: _EChatChannel.default.GENERAL,
  message: "no you suck. i go do a quest xD"
}, {
  sentAt: new Date(),
  author: "WizardOfTheHELL",
  channel: _EChatChannel.default.GENERAL,
  message: "quest??? wtf"
}, {
  sentAt: new Date(),
  author: "WizardOfTheHELL",
  channel: _EChatChannel.default.GENERAL,
  message: "quests suck. u drunk or what ?"
}, {
  sentAt: new Date(),
  author: _EChatChannel.default.SYSTEM,
  channel: _EChatChannel.default.SYSTEM,
  message: "The server will shut down in 1 hour for general maintanance and update."
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.PARTY,
  message: "have fun"
}
/* */
, {
  sentAt: new Date(),
  author: "b4ttl3m4st3r",
  channel: _EChatChannel.default.GUILD,
  message: "hey there whats going on? xD"
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.GUILD,
  message: "not much, hanging around with my bro and listening to music"
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.GUILD,
  message: "hey btw, did you know that you can get a free exp scroll from a special quest in palmas?"
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.DAMAGE,
  message: "Old Grey Wolf received 142 damage."
}, {
  sentAt: new Date(),
  author: "WizardOfTheHELL",
  channel: _EChatChannel.default.WHISPER,
  message: "homo lets go kill titans -.-"
}, {
  sentAt: new Date(),
  author: "b4ttl3m4st3r",
  channel: _EChatChannel.default.GUILD,
  message: "you serious ? dam i go do that lol"
}, {
  sentAt: new Date(),
  author: "b4ttl3m4st3r",
  channel: _EChatChannel.default.SHOUT,
  message: "no you suck. i go do a quest xD"
}, {
  sentAt: new Date(),
  author: "WizardOfTheHELL",
  channel: _EChatChannel.default.PARTY,
  message: "quest??? wtf"
}, {
  sentAt: new Date(),
  author: "WizardOfTheHELL",
  channel: _EChatChannel.default.GENERAL,
  message: "quests suck. u drunk or what ?"
}, {
  sentAt: new Date(),
  author: _EChatChannel.default.SYSTEM,
  channel: _EChatChannel.default.SYSTEM,
  message: "The server will shut down in 1 hour for general maintanance and update."
}, {
  sentAt: new Date(),
  author: "MedievelZ",
  channel: _EChatChannel.default.GUILD,
  message: "have fun"
}
/* */
];
var _default = messages;
exports.default = _default;